//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sympItem} from "../assets/lang.conf/root";
export default {
  name: "Symp_item",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      ...sympItem
    }
  },
  data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },
  props: [
    "riskLevelList",
    "mClass",
    "hClass",
    "tips",
    "classleve",
    "nClass",
    "isShow"
  ],
  methods: {
    getRiskImg(risk) {
      let direction = "normal";
      let img;
      if (
        !_.isNull(risk.direction) &&
        risk.key !== "legO" &&
        risk.key !== "legX" &&
        risk.key !== "legXO" &&
        risk.key !== "kneeOverstretch"
      ) {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },

    setModalInfo: function(risk) {
      this.$emit("setModalInfo", risk);
    }
  },
  created: function() {
    //console.log("this.riskLevelList",this.riskLevelList)
  }
};



// WEBPACK FOOTER //
// ./src/components/Symp_item.vue